import { inject, Injectable, Signal } from "@angular/core";
import { InfoboxCreateDto, InfoboxDto, InfoboxDtoPaging, InfoboxService, InfoboxUpdateDto } from "../../api";
import { BaseQueryService } from "./base-queries.service";
import { injectQuery } from "@tanstack/angular-query-experimental";
import { catchError, lastValueFrom } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class InfoboxQueryService extends BaseQueryService<
  InfoboxDto,
  InfoboxCreateDto,
  InfoboxUpdateDto,
  InfoboxDtoPaging,
  InfoboxService
> {
  override entityName = "Infobox";
  override queryService = inject(InfoboxService);
  override qS = {
    getById: this.queryService.getByIdAsync.bind(this.queryService),
    getAllNotDeleted: this.queryService.getAllNotDeletedAsync.bind(this.queryService),
    update: this.queryService.updateByIdAsync.bind(this.queryService),
    delete: this.queryService.softDeleteByIdAsync.bind(this.queryService),
    create: this.queryService.createAsync.bind(this.queryService),
  };

  getInfoboxesForPathQuery = (
    isEnabled: Signal<boolean>,
    path: Signal<string>,
  ) =>
    injectQuery(() => ({
      enabled: isEnabled(),
      queryKey: ["getInfoboxesForPath", path()],
      queryFn: () =>
        lastValueFrom(
          this.queryService.getAllForPath(path())
        ),
      retry: 0,
    }));
}
